// extracted by mini-css-extract-plugin
module.exports = {"nft-offers-list":"SentOffers_nft-offers-list__1a0Kb"};